module.exports = {
    // 头部
    nav: {
        title01: 'ホーム',
        title02: "博商について",
        title03: "教育センター",
        title04: "コース・カリキュラム",
        title05: "プラクティカルメンター",
        title06: "企業トレーニー",
        title07: "博商で学ぶ",
        title8: "ブランド概要　　　",
        title9: "ミッション・ビジョン",
        title10: "創設者概要",
        title11: "当スクールの歩み",
        title12: "ビジネスアーキテクチャ",
        title13: "社会的責任",
        title14: "社会的責任",
        title15: "評価実績",
        title16: "ニュース&イベント",
        title17: "ニュース&イベント",
        title18: "ニュース",
        title19: "業界レポート",
        title20: "出版物",
        title21: "お問い合わせ",
        title22: "产品亮点",
        title23: "コース一覧",
        title24: "個人学習システムクラス",
        title25: "グループ学習クラス",
        title26: "アカンパニーコース",
        title27: "リーダーコース",
        title28: "オンラインコース",
        title29: "コース評価",
        title30: "講師背景",
        title31: "講師評価",
        title32: "講師概要",
        title33: "博商师资导师",
        title34: "スクール概略",
        title35: "卒業生",
        title36: "卒業生",
        title37: "上場企業トレーニー",
        title38: "リソースプラットフォーム",
        title39: "協力メリット",
        title40: "チャネル協力",
        title41: "講師協力",
        title42: "カリキュラムについて",
        title43: "",
        title44: "",
        title45: "",
        title46: "",
        title47: "",
        title48: "",
        title49: "",
        title50: "",
        titleAi: "AI 製品",
    },
    // 底部
    footer: {
        one02: 'WeChat公式アカウント',
        one03: 'アプリダウンロード',
        one04: 'アプリ「ウィート」ダウンロード',
        one05: '広東省ICP備12055513号  ',
        one07: 'Copyright：企業：深圳市博商管理科学研究院',
        one08: 'フォローする',
        one9: 'サイトマップ',
        one10: 'ホーム',
        one11: '当スクールについて',
        one12: 'コース・カリキュラム',
        one13: '当スクールで学ぶ',
        one14: 'チャネル協力',
        one15: '講師協力',
    },

    // 面包屑
    breadcrumb: {
        breadText1: "ホーム",  // breadcrumb.breadText1
        breadText2: "博商について",
        breadText3: "ニュース&イベント",
        breadText4: "ニュース",
        breadText5: "業界レポート",
        breadText6: "出版物",
        breadText7: "プラクティカルメンター",
        breadText8: "講師概要",
        breadText9: "プラクティカルメンター",
        breadText10: "企業トレーニー　　",
        breadText11: "トレーニー",
        breadText12: "社会的責任",
        breadText13: "コース・カリキュラム",
        breadText14: "個人学習システムクラス",
        breadText15: "カリキュラムについて",
        breadText16: "",
        breadText17: "",
        breadText18: "",
        breadText19: "",
    },

    // 公用
    homeCommon: {
        showMore: "もっと見る",
    },
    // 首页
    homeVideo: {
        homeTitle1: "博商管理科学研究院<span>「経営管理指導に{years}年の経験を持つ教育機関」</span>",
        homeText1: "{years}年間の安定した急速な成長を経て、博商のブランドは持続的に拡大しています。国内では、博商は珠江デルタ地域を戦略的な中心地とし、北京、上海、広州など全国12都市にわたる分教育センターネットワークを構築しています。博商は2023年にグローバルな拡大を正式に開始し、東京、シンガポール、クアラルンプール、ジャカルタ、ホーチミン市に分教育センターを設立しました。博商のスタッフは、世界中の起業家やビジネスエリートに効率的で質の高い教育サービスと学習体験を提供するため、一丸となって頑張っています。",
        homeText1_1: "2024年から、ボーシャンはAIと企業経営教育の深い融合を進めています。現在、ボーシャンAIは企業経営をスマート時代へと導いています。30万件以上の実際の企業事例と業界の第一線での実践経験を基に、中小企業に最適なスマート経営ソリューションを提供しています。各講座には実践的なプランが付属しており、学んだ内容はすぐに使え、成果が見える・実現できる形で、企業の経営をより安心・省力・効率的にサポートします。",
        homeVideoLeft1: "<span>OMO学習プラットフォーム</span><span class='homeNum'>1</span>",
        homeVideoLeft2: "<span>都市教育センター</span><span class='homeNum'>17</span>",
        homeVideoLeft3: "<span>実践指導経験</span><span class='homeNum'>{years}</span>",
    },
    // 首页
    homeTeacher: {
        homeTitle2: "<span>講師陣</span>",
        homeText2: "当スクールのメンターは全て、国内外で活躍する一流の専門家やコンサルタントです。専門分野で平均15年以上の実務・研究に従事し、1人当たり平均指導企業は50社を超えており、確かな実践の経験を有しています。当スクールは2023年初めまでに、ビジネス系講師100人以上のIPを制作し、フォロワー総数は2億人を超え、業界をリードする存在となっています。",
        homeTeacherContent1: "プラクティカルビジネスメンター 100人以上",
        homeTeacherContent2: "企業指導経験 15年以上",
        homeTeacherContent3: "企業実践例 1500以上",
    },
    // 首页
    homeCourse: {
        homeTitle3: "<span>プラクティカルコース</span>",
        homeText3: '現代企業が直面する経営上の課題や、新世代起業家の学習ニーズに対応するため、博商はイノベーション実践 OMO（オンライン・オフライン融合）教育モデルを導入し、20年にわたる企業経営教育の経験を十分に融合させ、起業家向けに四大経営管理実践体系のコースをカスタマイズしました。これには、個人学習システムクラス、チーム共学研究社、伴走シリーズおよび先導シリーズが含まれます。',
    },
    // 首页
    home: {
        text1: "個人学習システムクラス",
        text2: "グループ学習クラス",
        text3: "アカンパニーコース陪跑系列",
        text4: "リーダーコース",
        text5: "eラーニング",
        text6: "企業トレーニー",
        text7: "当スクールではこれまで、10万以上のアントレプレナーを指導してきました。トレーニーの業界・分野はIT・インターネット、越境EC、新エネルギー、半加工食品、環境、家具、家電、ベーカリー、オウンドメディア、ホテル、ベビー・マタニティ用品、玩具、旅行、金融、教育、不動産、インダストリアルデザイン、建設、交通・運輸、家庭用化学、バイオ、医療、消費者向けサービスなど200以上にわたります。",
        text8: "カバー業界・分野 200以上",
        text9: "企業・アントレプレナー 10万以上",
        text10: "上場達成企業トレーニー 30社以上",
        text11: "協力メリット",
        text12: "当スクールは{years}年をかけてプラットフォームを構築し、リソースを展開し、育成モデルの革新を続けることで、中小企業の発展ニーズに即した万全のサービスチェーンをつくりあげています。歴史ある企業ビジネススクールとして、2021、2022両年には2年連続で中国トップアントレプレナー教育機関ランキングで5位に選出されています。",
        text13: "チャネル協力",
        text14: "現在、一線都市の30社以上とチャネル協力を進めています。これらの企業は、チャネルをエンパワーメントし、協力・チャネル規模を拡大しつつあります。",
        text15: "講師協力",
        text16: "当スクールは業界に先駆けてショート動画による顧客獲得モデルを模索し、オンライントラフィック拡大メンターを育成し、コロナ禍の中で業績を70%拡大しています。2023年初めまでに、ビジネス系講師100人以上のIPを制作し、フォロワー総数は2億人を超えています。",
    },

    // 关于博商
    about: {
        prizesDec1: "2021年最も影響力のある企業管理教育ブランド",
        prizesDec2: "企業格付け「AAA」評価",
        prizesDec3: "ボスム・インスティチュート 年度業界リーディングイノベーション賞 オーシャンエンジン",
        prizesDec4: "企業共同研究センター",
        prizesDec5: "2020年業界ベンチマーク教育グループ",
        prizesDec6: "2020年最も影響力のある企業ビジネススクール",
        prizesDec7: "2021中国トップアントレプレナー教育機関ランキング4位",
        prizesDec8: "2022中国トップアントレプレナー 教育機関ランキング3位",
        prizesDec9: "陽光同行賞",
        prizesDec10: "第3回エンジン賞・年度新鋭大賞",
        prizesDec11: "2025年度 起業家教育リーディングブランド",
        prizesDec12: "2025 Forbes 中国商業知識影響力シリーズ選考 — 業界影響力機関",
        aboutText1: "ブランド概要",
        aboutText2: "企業に寄り添う実践型ビジネススクール",
        aboutText3: "当スクールは2006年に設立され、「企業の成長を加速する」を合言葉に、「企業を研究し、企業に奉仕し、企業を宣伝する」の初心を忘れず、中国のアントレプレナーに経営管理・育成、コンサルティング・指導、リソース共有など、企業ライフサイクル全体を対象としたサービスを提供しています 。",
        aboutText4: "当スクールでは、OMO（オンラインとオフラインの融合）による教育モデルを業界に先駆けて導入し、アントレプレナーの皆様に四つの経営管理実践コース（「個人学習システムクラス」「グループ学習クラス」「アカンパニーコース」「リーダーコース」）を提供、オンライン学習プラットフォーム「ボスム・ウィート」を開放し、アントレプレナー学習者の飛躍的な成長を網羅的かつ正確にサポートしています。",
        aboutText5: "{years}年間の安定した急速な成長を経て、博商のブランドは持続的に拡大しています。国内では、博商は珠江デルタ地域を戦略的な中心地とし、北京、上海、広州など全国12都市にわたる分教育センターネットワークを構築しています。博商は2023年にグローバルな拡大を正式に開始し、東京、シンガポール、クアラルンプール、ジャカルタ、ホーチミン市に分教育センターを設立しました。博商のスタッフは、世界中の起業家やビジネスエリートに効率的で質の高い教育サービスと学習体験を提供するため、一丸となって頑張っています。 <div style=' margin-top:10px'>将来、博商はチームをさらに強化し、さらに多くの地域や都市に進出し、より多くの民間企業に支援と力を提供する予定です。</div> ",
        aboutText6: "ミッション・ビジョン",
        aboutText7: "スクールモットー",
        aboutText8: "ビジネスに高い志を 博学で意志の確固・ビジネス 正道に堅持",
        aboutText9: "当スクールは、学びを愛し、利益を超えた理想を掲げ、ビ ジネスの王道を追求するアントレプレナーの育成に取り 組んでいます。",
        aboutText10: "ミッション",
        aboutText11: "より良い世界を創造する",
        aboutText12: "ビジョン",
        aboutText13: "専門性とテクノロジーで、選ばれる成長パートナーに。成果で信頼を築き、成就で人を輝かせる。",
        aboutText14: "バリュー",
        aboutText15: "真心をもって顧客を支援 専門性を背景とした革新・協力",
        aboutText16: "創設者概要",
        aboutText17: "曽任偉",
        aboutText18: "当スクール共同創設者・院長",
        aboutText19: "シンガポールサンズ博商社长",
        aboutText20: "香港理工大学管理学博士課程修了",
        aboutText21: "企業コーチ・実践エキスパート，著名な「博三角」の概念を提唱",
        aboutText22: "20年にわたり成長ベースの企業システム管理ソリューションの研究・実践に取り組む",
        aboutText23: "「安奈児」「奥拓」「海洋王」など多くの企業の事業規模拡大を支援",
        aboutText24: 'ビジネスモデルの革新・設計を得意とし、長年にわたり企業の成長性の研究、組織運営力の構築、チーム実行力の向上に取り組み、広く知られる企業成長ベースモデル <span class="rightRed">「博三角」</span>の概念を提唱しています。 <span class="rightRed">「博三角」</span>では、企業の安定的な成長には「明確な戦略目標」「効率的な組織運営力」「トップの影響力」の三つが必要としています。戦略とは企業の方向性を示すものであり、経営の指針、リソース統合の根拠となるものです。組織運営力は企業の発展に最も必要とされる、最も得難い要素であり、企業の効率を決定づけるものです。トップは企業のかじ取り役であり、その影響力は企業文化に深く刻み込まれます。<span class="rightRed">「博三角」</span>は企業の成長・発展の強力なツールとなっています。',
        aboutText25: "劉炳成",
        aboutText26: "当スクール共同創設者・院長",
        aboutText27: "清華大学深圳大学院ボスム企業共同研究センターリーダーシップエキスパート",
        aboutText28: "元南京陸軍指揮学院優秀士官教員",
        aboutText29: "「ブレークスルーリーダーシップ」開発者",
        aboutText30: '若年で軍に入隊し、解放軍南京陸軍指揮学院に学び、優秀な成績を収めたことから教員に採用され、軍事組織指揮の教育訓練・研究に携わってきました。この間、南京陸軍指揮学院から何度も「優秀士官教員」の称号を授与されています。 競争の激しい分野における組織リーダーシップの教育訓練を得意としています。平和な時代ではビジネスの場こそが戦場です。ビジネスという戦いの最前線にある企業にとっては、体系的かつ専門的な組織管理能力の向上が極めて主要となります。劉院長は自らの専門である軍事訓練技術によって企業研修をエンパワーメントし、当スクール関係者ともに企業を指導しています。',
        aboutText31: "当スクールの歩み　博商の歩み",
        aboutText32: '2020年～ <span class="rightRed">（開拓）</span>',
        aboutText33: "オフライン教育からOMOモデルへの移行",
        aboutText34: '2015-2019年<span class="rightRed">（独自） </span>',
        aboutText35: "分離・独自ブランド発展",
        aboutText36: '2006～2014年 <span class="rightRed">（進化）</span>',
        aboutText37: "清華大学深圳大学院所属",
        aboutText38: "ビジネスアーキテクチャ",
        aboutText39: "社会的責任",
        aboutText40: "企業は社会の一部であり、その存続は社会から提供される一切のものに依存します。当スクールは、中国企業の発展を支援する過程で、相応の社会的責任を負い、これを積極的に果たしてきました。2015年7月20日には「ボスム慈善財団」を設立、「博愛・聚善・貢献・奉仕」をモットーに、当スクールで学ぶ人々と慈善活動に従事する人々に社会貢献活動の場を提供することを目的としています。個人の力を組織として活かすことで、社会貢献活動を実施し、社会にポジティブなインパクトを与え、その調和を促します。",
        aboutText41: "評価実績",
        aboutText42: "ニュース&イベント",
        aboutText43: "ニュース",
        aboutText44: "業界レポート",
        aboutText45: "出版物",
        aboutText46: "活動の状況",
    },

    // 教学中心
    teaching: {
        teachListCompany1: "深圳本部",
        teachListAddress1: "所在地： 深圳市南山区前海信利康ビル16/17/21/25/33階",
        teachListCompany2: "北京支部",
        teachListAddress2: "所在地： 北京市朝陽区香賓路66号保利プラザ東棟2階",
        teachListCompany3: "上海支部",
        teachListAddress3: "所在地： 上海市青浦区高光路169弄虹橋時代広場2区画2号棟5階",
        teachListCompany4: "広州支部",
        teachListAddress4: "所在地： 広東省広州市海珠区琶洲街道銘豊広場A棟2810ユニット",
        teachListCompany5: "仏山支部",
        teachListAddress5: "所在地： 仏山市南海区桂瀾北路26号招商置地センター3号棟11階",
        teachListCompany6: "東莞支部",
        teachListAddress6: "所在地： 東莞市松山湖区科技二路5号中国電子南方ソフトウェアパークA棟1006号室",
        teachListCompany7: "杭州支部",
        teachListAddress7: "所在地： 杭州市濱江区聚業路1号興耀科創城·杭州双炭技術産業園C棟5階",
        teachListCompany8: "蘇州支部",
        teachListAddress8: "所在地： 蘇州高新区獅山路22号人材広403/1001/1007/1008号室",
        teachListCompany9: "重慶支部",
        teachListAddress9: "所在地： 重慶市南岸区南濱路22号長江国際写字楼25階",
        teachListCompany10: "成都支部",
        teachListAddress10: "所在地：成都市成華区成華発展ビル18階",
        teachListCompany11: "長沙支部",
        teachListAddress11: "所在地：長沙市芙蓉区万家麗中路一段176号旺徳府国際ビル13階",
        teachListCompany12: "武漢支部",
        teachListAddress12: "所在地：湖北省武漢市徐東大街89号金禾センター2801-02",
        teachListCompany13: "シンガポール支部",
        teachListAddress13: "所在地：163 Kallang Way , #07-13 , Singapore (349256)",
        teachListCompany14: "クアラルンプール支部",
        teachListAddress14: "所在地：Level 27, 1 Powerhouse, No. 1, Persiaran Bandar Utama,Bandar Utama, 47800 Petaling Jaya, Selangor Malaysia",
        teachListCompany15: "ジャカルタ支部",
        teachListAddress15: "所在地：Landmark Pluit Gedung B9 / Lantai 12 (Jl. Pluit Selatan Raya RT.6/RW/10, Pluit Penjaringan, Jakarta Utara)",
        teachListCompany16: "ホーチミン支部",
        teachListAddress16: "所在地：Tầng 11, Khu cao ốc văn phòng - thương mại - dịch vụ tại lô 5.5, số 8-10 đường Mai Chí Thọ, Phường Thủ Thiêm, Thành phố Thủ Đức, Thành phố Hồ Chí Minh, Việt Nam",
        teachText1: "当スクール展開地域",
        teachText2: "{years}年の安定的かつ急速な発展を経て、当スクールの展開地域は拡大し続けています。現在、当スクールは珠江デルタを戦略的基軸として、全国の12の重点都市、及び海外各地に10万以上のアントレプレナートレーニーを指導しています。1700人以上のスタッフが協力してトレーニーに効率的かつ質の高い教育サービスと学習体験を提供しています。",
        teachText3: "当スクールは今後も、事業規模をより多くの地域・都市へと拡大し、より多くの企業をエンパワーメントしていきたいと考えています",
    },

    // 课程服务
    course: {
        courseText1: "产品亮点",
        courseText2: " 针对当今企业所面临的运营管理难题，以及新一代企业家的学习习惯和需求，博商创新实践OMO教学模式，充分融合17年线下优势及多年线上管理培训课程经验,为企业家定制出四大经营管理实践体系课程,涵盖个人学习系统班、团队共学研习社、陪跑系列及领跑系列，以及一个线上学习平台——博商小麦。",
        courseText3: "通过“有模型、有流程、有工具、有案例、有练习”的“五有课程”和“预学习用链”的教学方法，打磨出了实战落地的核心优势。",
        courseText4: "四大体系·九大领域",
        courseText5: "五有课程",
        courseText6: "教学特色",
        courseText7: "线上线下",
        courseText8: "コース一覧",
        courseText9: "コース評価",
        courseText10: "潘宣成さん",
        courseText11: "<text class='classSty'>受講コース：</text>財務徹底攻略トレーニングキャンプ",
        courseText12: "コースでは数多くの講師の実践の経験が示されました。浅いところから次第に深いところへと、とっつきにくかった財務を楽しく理解できました。財務とは単なる事務職の集計作業ではなく、実業務と密接に関わっており、うまく活用すれば収入を増やし、支出を抑えることができるものであることが分かりました。",
        courseText13: "王頓さん",
        courseText14: "<text class='classSty'>受講コース：</text>卓越組織進化プログラム",
        courseText15: "受講して学んだことをあげてみます。（1）パフォーマンスは「SMART」に忠実に従って各部に落とし込む必要があること。（2）評価面談は全員に同じ方法を一律適用するのではなく、方法を工夫する必要があること。（3）評価面談前には、相手が求めるものを明らかにしておくこと。（4）社の戦略目標は部門ごとの業績まで細分化し、定量化できるようにすること。（4）人事査定ではロジックを明確にし、昇給は段階的に行っていくこと。",
        courseText16: "兪衛華さん",
        courseText17: "<text class='classSty'>受講コース：</text>ニュービジネス事業拡大実践クラス",
        courseText18: "生き生きとしていて頭に残りやすい指導内容でした。例えば、大局から業界と企業の立ち位置を観察し、業界に大手が現れたら業界セグメンテーションの展望の分析・掘り起こしを行ってそれを突破口にし、自分が詳しい業界や製品に注力していくことを学びました。",
        courseText19: "郑成林学员",
        courseText20: "<text class='classSty'>受講コース：</text>F8营销系统",
        courseText21: "销售只是营销最初始的一个内容，而营销却是一套整体的系统，从市场调研、战略规划、品牌策划，到产品策划以及渠道建设、销售推广等，缺一不可。因此,要想做成一个好的品牌，需要先找到一个好的品类，而品类细分才能更聚焦，这些认知对我来说，可谓受益匪浅。",
        courseText22: "個人学習システムクラス",
        courseText23: "グループ学習クラス",
        courseText24: "アカンパニーコース",
        courseText25: "リーダーコース",
        courseText26: "オンラインコース",
        // tableDataLabel表头
        tableDataLabel1: "コース名",
        tableDataLabel2: "個人学習システムクラス",
        tableDataLabel3: "グループ学習クラス",
        tableDataLabel4: "アカンパニーコース",
        tableDataLabel5: "リーダーコース",
        tableDataLabel6: "オンラインコース",

        // tableDataList表格内容
        tableDataListDate1: '対象者',
        tableDataListName1: '創業者・上級管理職',
        tableDataListAddress1: '創業者+中・上級管理職/業務ライン責任者',
        tableDataListTogether1: '創業者・創業者+経営幹部',
        tableDataListLead1: '企業・チーム',
        tableDataListOnline1: '起業家・ビジネスエリート',

        tableDataListDate2: '授课时间',
        tableDataListName2: '1年',
        tableDataListAddress2: '2-3日',
        tableDataListTogether2: '3～12ヶ月',
        tableDataListLead2: '3～12ヶ月',
        tableDataListOnline2: '動画視聴時間（再生無期限）',

        tableDataListDate3: '受講場所',
        tableDataListName3: '全国',
        tableDataListAddress3: '全国',
        tableDataListTogether3: '全国',
        tableDataListLead3: '社内+オンライン',
        tableDataListOnline3: 'オンライン',

        tableDataListDate4: '定番プログラム・コース',
        tableDataListName4: "「エグゼクティブプログラム」 <br>「エリートプログラム」 <br>「キャピタルプログラム」",
        tableDataListAddress4: '「ショート動画で勝つ」<br> 「ライブ配信で勝つ」<br> 「株主構成で勝つ」<br> 「財務・税務で勝つ」<br> 「販売で勝つ」<br> 「組織力を引き出す」',
        tableDataListTogether4: '「ストラテジックコーチ・アカンパニープログラム」 <br>「90日間で組織を変革する」',
        tableDataListLead4: '経営管理専門コンサルティング  <br> 企業ショート動画専門コンサルティング',
        tableDataListOnline4: '「曽任偉：ビジネスモデル実践トレーニングキャンプ」  <br>「張琦：トラフィック拡大・全チャネル成長」',

        tableDataListDate5: '',
        tableDataListName5: 'https://www.baidu.com/',
        tableDataListAddress5: 'https://www.baidu.com/',
        tableDataListTogether5: 'https://www.baidu.com/',
        tableDataListLead5: 'https://www.baidu.com/',
        tableDataListOnline5: 'https://www.baidu.com/',
    },

    // 实战导师
    combat: {
        combatText1: "講師背景",
        combatText2: "当スクールのメンターは全て、国内で活躍する一流の専門家やコンサルタントです。専門分野で平均15年以上の実務・研究に従事し、1人当たり平均指導企業は50社を超えており、確かな実践の経験を有しています。当スクールは2023年初めまでに、ビジネス系講師75人以上のIPを制作し、フォロワー総数は2億人を超え、多くのトラフィックの獲得と収益化を実現し、業界をリードする存在となっています。",
        combatText3: "プラクティカルメンター 75人以上",
        combatText4: "",
        combatText5: "実践指導経験15年以上",
        combatText6: "",
        combatText7: "",
        combatText8: "実践例1500以上",
        combatText9: "講師評価",
        combatText10: "トレーニーの声 <span>一部</span>",
        combatText11: "実践指導テーマ：株主構成の設計",
        combatText12: "受講を通して学んだこと：",
        combatText13: "先生による社内コンサルティング指導のことを思い出すと、今でも胸が高鳴り、社の幹部と話したくなります。その日の午後、先生は当社からの株主構成設計に関する質問について、私たちにも分かりやすい言葉で、流れるように見事な回答を示してくれました。さすがトップ500企業のプラクティカルメンターだと感嘆させられました。社内での指導内容は、この5年間の学習で完全に身につき、知識も実践を通じて昇華されています。本当にありがとうございます。",
        combatText14: "—大任空調 曹任さん",
        combatText15: "実践指導テーマ：業務拡大の方向性",
        combatText16: "受講を通して学んだこと：",
        combatText17: "先生に社内で経営診断・指導を受けた社員はみな、強い感慨を覚えていました。先生の指導は当社に新たな思考を提示してくれました。私は社を引き継いでから、既存のモデルから脱却して新たな事業拡大の手がかりをつかみたい、新たな成長事業を探したいと悩み続けてきました。しかし、先生に言われた「まずは主要かつ緊急な仕事から片付けなさい」という言葉は、周りが見えなくなっていた私の目を覚ましてくれました。",
        combatText18: "——成都徳昆グループ 王さん",
        combatText19: "講師採用基準",
        combatText20: "20年の指導経験を通じ、当スクールでは「実践の経験」「中小企業への理解」「巧みな指導」「思いやり」という講師の採用基準を確立しています。厳しい採用条件をクリアした一流の講師と「モデル」「フロー」「ツール」「ケース」「プラクティス」の五つを備えたコースによって、企業に優れた学習ソリューションを提供しています。",
        combatText21: "講師概要",
        combatText22: "一流の講師陣  ",
        combatText23: "プラクティカルメンター",
        combatText24: "博商は、定期的に、国際的リーダー、著名なアントレプレナー、ビジネスナレッジ専門家などを講師に招き、最先端の方策及び知識を学生の皆様と共有することで、個々の学生 の視野を拡大することに努力しています。",
        combatText25: "博商は、個別の専門分野の実戦的な講師と緊密に連携し、学生が有効的な実戦的経験を獲得でき、実質的 な飛躍を実現できるよう、終始一貫して、学生に1対1のサポートを提供します。",
        combatText26: "",
        combatText27: "",
        combatText28: "",
        combatText29: "",
        combatText30: "",
        combatText31: "",
        combatText32: "",
        combatText33: "",
    },

    // 企业学员
    student: {
        studentText1: "トレーニー概略",
        studentText2: "当スクールではこれまで、30万以上のアントレプレナーを指導してきました。トレーニーの業界・分野はIT・インターネット、防犯、ペット、Eコマース、電子機器、不動産、工業デザイン、化学産業、新エネルギー、環境保護、加工業、家具・インテリア、家電、建設、交通、教育、金融、農林畜産業・漁業、卸売・小売、自動車、軽工業、日用化学品、ラグジュアリー商品、生活サービス、バイオ、スポーツ・文化、エンターテインメント、医療など200以上にわたります。…",
        studentText3: "200以上",
        studentText4: "カバー業界・分野",
        studentText5: "30万以上",
        studentText6: "企業・アントレプレナー",
        studentText7: "30社以上",
        studentText8: "上場達成企業トレーニー ",
        studentText9: "卒業生",
        studentText10: "上場企業トレーニー",
        studentText11: "リソースプラットフォーム",
        studentText12: "佳士科技",
        studentText13: "股票代码-300193",
        studentText14: "昌红科技",
        studentText15: "股票代码-300151",
        studentText16: "捷顺科技",
        studentText17: "股票代码-002609",
        studentText18: "星源材质",
        studentText19: "股票代码-300568",
        studentText20: "长园集团",
        studentText21: "股票代码-600525",
        studentText22: "科陆电子",
        studentText23: "股票代码-002121",
        studentText24: "名雕装饰",
        studentText25: "股票代码-002830",
        studentText26: "新纶新材",
        studentText27: "股票代码-002341",
        studentText28: "新宏泽",
        studentText29: "股票代码-002836",
        studentText30: "拓斯达",
        studentText31: "股票代码-300607",
        studentText32: "胜蓝股份",
        studentText33: "股票代码-300843",
        studentText34: "衍生集团",
        studentText35: "股票代码-06893",
        studentText36: "三峡水利",
        studentText37: "股票代码-600116",
        studentText38: "意华股份",
        studentText39: "股票代码-002897",
        studentText40: "崧盛股份",
        studentText41: "股票代码-301002",
        studentText42: "奥海科技",
        studentText43: "股票代码-002993",
        studentText44: "英威腾",
        studentText45: "股票代码-002334",
        studentText46: "证通电子",
        studentText47: "股票代-002197",
        studentText48: "快意电梯",
        studentText49: "股票代码-002774",
        studentText50: "雪天盐业",
        studentText51: "股票代码-600929",
        studentText52: "达瑞电子",
        studentText53: "股票代码-300976",
        studentText54: "超频三",
        studentText55: "股票代码-300647",
        studentText56: "齐心集团",
        studentText57: "股票代码-002301",
        studentText58: "金博股份",
        studentText59: "股票代码-688598",
        studentText60: "德生科技",
        studentText61: "股票代码-002908",
        studentText62: "普邦股份",
        studentText63: "股票代码-002663",
        studentText64: "汇创达",
        studentText65: "股票代码-300909",
        studentText66: "华宝新能",
        studentText67: "股票代码-301327",
        studentText68: "捷邦科技",
        studentText69: "股票代码-301326",
        studentText70: "唯特偶",
        studentText71: "股票代码-301319",
        studentText72: "佳裕达",
        studentText73: "NASDAQ: JYD",
        studentText74: "ボスム・アソシエーション",
        studentText75: "独自のインターネットでのハイブモデルを採用し、イノベーションを駆動力とし、大規模な業界団体・組織、メインストリームメディア、民間企業研究調査機関及び現代のビジネス思想家、業界専門家、企業のリーダーなど、これらを連携させることにより、当アカデミー学生の生涯学習を可能にするプラットフォームを構築しています。",
        studentText76: "リソース・アソシエーション",
        studentText77: "各受講者用のリソース統合プラットフォームを構築し、定期的なイベントを通じてリソースの効率的なリンク、正確なマッチングを図り、企業の迅速な市場開拓を支援し、イノベーション・エンパワーメントにつなげています。現在、大湾区アソシエーション本部、博明アソシエーション支部、博龍アソシエーション支部があります。",
        studentText78: "百人アソシエーション",
        studentText79: "著名な学者及び起業家をメンター・顧問として参与させ、テーマ学習、ベンチマーク企業各社への現場訪問、非公開取締役会及びリソース統合などでの体験を通して、将来の業界リーダー100人の育成に取り組んでおり、当アカデミー学生の企業に対する人材市場競争力及び業界影響力の永続的な向上に尽力しています。",
        studentText80: "トレーニー",
        studentText81: "トレーニー事例",

    },

    // 加入博商
    join: {
        joinText1: "協力メリット",
        joinText2: "業界展望",
        joinText3: "共研産業研究院のデータによると、2026年の中国企業向け研修市場の全体規模は4,069.5億元に達し、前年比9.8%増加すると予測されています。業界の構造は依然として高度に分散した「水滴型」の発展傾向を示しており、主要な機関の収益は市場全体の規模の0.1%未満に過ぎません。これは、中国企業が経営管理において大きな向上の余地があることを意味しており、ブルーオーシャン産業に属しているため、早期に開拓・展開する企業ほどより大きな発展優位を得られるでしょう。",
        joinText4: "市場監督管理総局のデータによると、2026年4月末時点で全国で登録されている民間企業は6102.2万社に達し、前年同期比で5.6％増加し、企業総数の92％以上を占めています。1日平均約2.3万社が新設され、事業主体の発展は安定して良好です。これが中国経済で最も活発なミクロ基盤を形成しています。",
        joinText5: "民間企業数が6,100万社を突破",
        joinText6: "中国中小企業協会のデータによると、国内で新たに登録された企業の1年以内の生存率は約60%、3年以内の生存率は20%未満、5年以内の生存率はわずか7%～8%です。創業失敗の約70%は資金繰りの断絶に起因しており、その根本的な原因はしばしば体系的な経営管理体制の欠如です。専門的な経営管理を学ぶことは、企業の永続化の基礎であり必須となっています。",
        joinText7: "専門的経営が企業の硬直的需要に",
        joinText8: "世界銀行が中国の2189社の企業を対象に行った調査によると、59のビジネス環境評価項目のうち、中国は12項目で世界最高水準に達しており、6つの評価分野のデータはすべて中央値を上回っています。2025年5月20日に「民間経済振興法」が正式に施行され、民間企業が長年直面してきた核心的課題に体系的に対応し、民間経済を守る「画期的な出来事」と位置づけられています。",
        joinText9: "ビジネス環境の継続的な改善",
        joinText57: "89％の企業は「研修ROIの定量化」をコア評価基準としており、82％の企業は実践型コースを第一に選択しています。中小企業のオンライン研修ニーズの成長率は72％に達し、大企業の45％を大きく上回っています。AIGCコースの学習時間は前年比で54倍に増加しており、企業研修は「任意支出」から「必須投資」へとアップグレードしています。",
        joinText58: "AIが研修の価値を再構築",
        joinText10: "当スクールの実力",
        joinText11: "17",
        joinText12: "个",
        joinText13: "都市教育センター",
        joinText14: "100",
        joinText15: "位",
        joinText16: "プラクティカルメンター",
        joinText17: "200",
        joinText18: "个",
        joinText19: "カバー業界",
        joinText20: "30",
        joinText21: "万",
        joinText22: "認証トレーニー",
        joinText23: "20",
        joinText24: "年",
        joinText25: "指導経験",
        joinText26: "200",
        joinText27: "个",
        joinText28: "実力製品",
        joinText29: "協力展開",
        joinText30: "当スクールは民間経済発展トレンドについて深いインサイトを行っており、17年をかけてプラットフォームを構築し、リソースを展開し、よりオープンでウィン―ウィンなビジネス構造とコンバージョンバリューの構築を追求しています。当スクールは全国からトレーニーを募集し、講師協力を受けつけ、リソースを集約し、ブランド運営の全面的なイノベーションをエンパワーメントしています。",
        joinText31: "チャネル協力",
        joinText32: "当スクールの全国チャネル協力部は2023年3月に設置されました。あらゆる業界から、当スクールとともにベストな協力モデルを構築し、プラットフォームリソースを共有し、チャネル規模を拡大していくチャネル代理店を募集することが役割です。現在、全国からチャネル代理店を募集しています。ともに中国中小企業の発展を支援することを志す、各業界のチャネル代理店からのお問い合わせをお待ちしています。",
        joinText33: "協力の内容",
        joinText34: "専門チームによるサポート・マーケティング指導・情報システムサポート・イベントサポート・定期スタッフ研修などがあります。",
        joinText35: "協力バリュー",
        joinText36: "プラットフォームリソースの共有：",
        joinText37: "20年の経験を持つ企業指導スクールとして、これまで  30万以上の企業・アントレプレナートレーニーを指導し、200以上の業界リソースをカバーしています。",
        joinText38: "管理能力のエンパワーメント：",
        joinText39: "業界3位の企業指導スクールとして、フロンティア・テクノ ロジーと業界発展の関係を深くインサイトし、最新の政策情報、システム操作、ブランド講師エンパワーメント、プラクティカル製品エンパワーメントなど合理的な管理手法を提供しています。",
        joinText40: "成約ボーナス：",
        joinText41: "常に協力の拡大を模索し、チャネル収益の拡大を実現し、業界内でも屈指の水準の成約ボーナスを提供しています。",
        joinText42: "講師協力",
        joinText43: "博商の講師事業部は、中国の中小企業のニーズに即した実戦型経営管理メンターの育成に取り組んでいます。メンター個人IPブランド構築、オンラインコース協力、エグゼクティブクラス長期プログラムなどを通じ、企業の発展を全力でサポートしています。2023年初めまでに、ビジネス系講師30人以上のIPを制作し、フォロワー総数は2億人を超え、業界をリードする存在となっています。",
        joinText44: "協力の内容",
        joinText45: "個人IPブランド構築、オンラインコース協力、エグゼクティブクラス長期プログラム",
        joinText46: "選抜の流れ",
        joinText47: "①評価：人物・指導力、中小企業の指導に向いているか",
        joinText48: "②指導ブラッシュアップ：コースを当スクールトレーニーの個別の状況に即したものにできる",
        joinText49: "③試験指導：講師・トレーニーのコース後の意見",
        joinText50: "④協力開始",
        joinText51: "連絡先",
        joinText52: "協力の詳細につきましては、二次元コードをスキャンして当スクールにお問い合わせください",
        joinText53: "右側をスキャンして講師連絡先を追加する",
        joinText54: "連絡先",
        joinText55: "協力の詳細につきましては、二次元コードをスキャンして当スクールにお問い合わせください",
        joinText56: "右側をスキャンして講師連絡先を追加する",

    },

    // 社会责任
    responsibility: {
        resText1: "社会的責任",
        resText2: "財団概要",
        resText3: "深圳博商公益基金は深圳博商管理科学研究院股份有限公司が発起し、深圳市民政局の審査承認を経て、2015年に設立された非公募基金である。2021年に慈善団体として認定され；2022年に博商公益基金ボランティアチームが正式に設立され、党支部が設立された；2023年11月には3A級社会組織として評価された。",
        resText4: "「愛を分かち合い、愛を伝え、博愛で世界を温める」というビジョンを持ち、「公益の種子を蒔き、慈善精神を弘揚する」という使命のもと、「児童関心と教育発展」「美しい都市と農村振興」「自然災害と緊急救護」「高齢者介護と孤児・障害者支援」の4大分野に焦点を当てている。各種公益プロジェクトを通じて社会各界の愛ある人々が共に慈善事業に貢献するよう呼びかけ、より多くの人々の慈善への情熱を掻き立て、積極的な慈善公益参加を促し、愛とケアを世界のあらゆる角落に届け、社会の進歩と発展に貢献している。",
        resText6: "財団概要",
        resText7: "児童関心と教育発展",
        resText8: "基金会は創設理念を堅持し、公益助学プラットフォームを構築し、貧困児童、流動児童、留守児童の困窮を改善する。児童・青少年の健全な成長サービスを提供し、学校の教育施設改善を支援し、経済的に困難な家庭の学生の夢実現を援助している。2010年以来、基金は「愛心図書館」20カ所以上、「愛心小学校」3校を寄贈。孔子像10体以上を建立；留守児童への関愛「渡り鳥計画」を7シーズン開催、700名以上の留守児童に恩恵をもたらした。2024年には革新的な「博愛クラス」を立ち上げ、優秀だが困難にある学生の夢実現を支援。さらに四川、貴州、雲南、福建、広西、湖北など多くの地域でターゲット型助学プロジェクトを展開……博商人は愛があり、行動で児童に関わり、児童教育発展を支援し、子供たちに社会からの温かさを届けている。",
        resText9: "",
        resText10: "自然災害と緊急救護",
        resText11: "災害の前では、我々は救助者であると同時に希望の伝達者でもある。基金会のタイムリーな救援活動一回ごと、効果的な救済活動一回ごとが、被災者の生命安全の保障となり、彼らにさらなる希望をもたらす可能性がある。",
        resText12: "美しい都市と農村振興",
        resText13: "都市と農村は、二輪の花のように人類文明の絢爛たる絵巻を共に咲かせる。公益事業の推進者として、基金会は公益活動を紐帯とし、都市のグリーンかつ持続可能な発展を支援すると同時に、農村振興という偉大な事業に積極的に取り組み、農村に再び活力を吹き込んでいる。",
        resText14: "高齢者介護と孤児・障害者支援",
        resText15: "社会という大家庭の中で、高齢者、孤児、障害者はすべて特別な関心を必要とするグループである。基金会は高齢者支援、側湾症児童、先天性心疾患患者、貧困老人家庭への関愛などのプロジェクトを実施し、高齢者介護と孤児・障害者支援の2大公益プロジェクトを密接に統合し、これら弱勢グループに支援とサポートを提供し、すべての命が尊重され関愛されるようにしている。",
        resText16: "",
        resText17: "2021～2024年：緊急救助員研修を7回実施",
        resText18: "2021年：「豫」我同心 河南洪水救援",
        resText19: "2024年：梅州平遠洪水救済",
        resText20: "2020年：「同心行動」新型コロナ寄付",
        resText21: "第6回「博商林」公益植樹活動を実施",
        resText22: "第3回「生命之光」千人献血キャンペーンを開催",

    },

    // 新闻动态
    boSumDynamic: {
        dynamicText1: "ニュース",
        dynamicText2: "業界レポート",
        dynamicText3: "出版物",
        dynamicText4: "メディア連絡先",
        dynamicText5: "Eメール",
        dynamicText6: "所在地：深圳市前海深港合作区媽湾十九単元03街坊信利康ビル17階",
        dynamicText7: "ニュース",
        dynamicText8: "業界レポート",
        dynamicText9: "レポート全文をダウンロードされたい場合、二次元コードをスキャンして当スクールにお問い合わせください",
        dynamicText10: "右側をスキャンして講師連絡先を追加する→",
        dynamicText11: "レポート全文をダウンロードされたい場合、二次元コードをスキャンして当スクールにお問い合わせください",
        dynamicText12: "右側をスキャンして講師連絡先を追加する→",
        dynamicText13: "当スクールのメンターは全て、国内外で活躍する一流の専門家やコンサルタントです。専門分野で平均15年以上の実務・研究に従事し、1人当たり平均指導企業は50社を超えており、確かな実践の確かな実践の経験を有しています。2023年初めまでに、ビジネス系講師100人以上のIPを制作し、フォロワー総数は2億人を超え、業界をリードする存在となっています。",
        dynamicText14: "検索する名前を選択または入力してください",
        dynamicText1401: "入力してください",
        dynamicText15: "検索",
        dynamicText16: "当スクールではこれまで、10万以上のアントレプレナーを指導してきました。トレーニーの業界・分野はIT・インターネット、越境EC、新エネルギー、半加工食品、環境、家具、家電、ベーカリー、オウンドメディア、ホテル、ベビー・マタニティ用品、玩具、旅行、金融、教育、不動産、インダストリアルデザイン、建設、交通・運輸、家庭用化学、バイオ、医療、消費者向けサービスなど200以上にわたります。…",
        dynamicText17: "",
        dynamicText18: "",
        dynamicText19: "",
        dynamicText20: "",
    },

    // 课程资讯  {{ $t('consult.consultText1') }}
    consult: {
        consultText1: "受講を希望する",
        consultText2: "お名前",
        consultText3: "氏名を入力してください",
        consultText4: "電話番号",
        consultText5: "電話番号を入力してください",
        consultText6: "社名",
        consultText7: "社名を入力してください",
        consultText8: "役職",
        consultText9: "役職を入力してください",
        consultText10: "ご注意",
        consultText11: '1.お問い合わせありがとうございます。<i style="color: red;"> *</i>は入力必須項目です。',
        consultText12: "2.今後の連絡のため、実際の情報をご入力ください（お送りいただいたお客様の情報が外部に漏れることはありません）。ありがとうございました",
        consultText13: "送信",
        consultText14: "トレーニー募集ホットライン：18927497646",
        consultText15: "トレーニー募集Eメール：yangqing@bosunm.com",
        consultText16: "",
    },

    // 后面修改的课程 {{ $t("courseC.courseCText1") }}
    courseC: {
        courseCText1: "コースの価値",
        courseCText2: "20年間にわたる実践的な教育経験に基づき、博商は、中小企業及びアントレプレナーの皆様がビジネスを行う際に、その指針となる科学的でありかつ最先端のマネージメント知識に基づく方法を提供できるように取り組んでいます。100人を超える豊富な実戦経験を積んだプロの講師陣が、アントレプレナーの皆様に、有効性が確実なランディングコース及びガイダンスを提供し、同時に学生企業の現場に赴くことで、企業のマネージメント及び運営の際に直面する課題に1対1のコーチングでその解決を支援いたします。",
        courseCText3: "マネージメントについての認識と知識を包括的に向上させ",
        courseCText4: "企業の競争優位性を涵養しながら",
        courseCText5: "トップクラスのエキスパートたちが現場で実戦の課題を指導することで",
        courseCText6: "オンライン及びオフラインの間の連携をシームレスに統合します",
        courseCText7: "",
        courseCText8: "",
        courseCText9: "",
        courseCText10: "",
        courseCText11: "",
        courseCText12: "",
        courseCText13: "",
        courseCText14: "",
        courseCText15: "",
        courseCText16: "",
        courseCText17: "",
        courseCText18: "",
        courseCText19: "",
        courseCText20: "",
    },

    // 招聘
    recruit: {
        recruitText1: "新卒採用",
        recruitText2: "中途採用",
        recruitText3: "講師募集",
    }


}



// WEBPACK FOOTER //
// ./src/lang/ja.js